import React from 'react';
import Page from '../../layout/Page';
import Surveys from './Surveys';

const SurveysPage = () => (
    <Page title='Survey Results' icon='mobile'>
        <Surveys />
    </Page>
);

export default SurveysPage;
